import {useSelf} from "../agent/useSelf.ts";
import {TruckStub, watchTruckByCrewTqo} from "../rpc/webrpc-client.gen.ts";
import {InfallibleUseResult, transformUseResult} from "../util/hookutil.tsx";
import {useInfallibleQuery} from "../util/useInfallibleQuery.tsx";
import {useMothership} from "../tq/tqx.tsx";

export function useMountedTruck(): InfallibleUseResult<TruckStub | null> {
    const mama = useMothership();
    const {data: self} = useSelf();
    return transformUseResult({
        from: useInfallibleQuery(
            watchTruckByCrewTqo(mama, self?.id ? {crewId: self.id} : undefined)),
        via: (from) => from ?? null,
    });
}


